import { render, staticRenderFns } from "./commodity-add-or-update.vue?vue&type=template&id=2558fb5e&scoped=true"
import script from "./commodity-add-or-update.vue?vue&type=script&lang=js"
export * from "./commodity-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./commodity-add-or-update.vue?vue&type=style&index=0&id=2558fb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558fb5e",
  null
  
)

export default component.exports